module.exports = __webpack_public_path__ + "static/191108-BS-IGB-New-F1-Hongsils-Treasure-Draw-8dbadf821cb487534a07041571d94a7a.jpg";